import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'alphasearch',
    templateUrl: 'alphasearch.component.html',
    styleUrls: []
})

export class AlphasearchComponent implements OnInit, OnDestroy {
    data: any = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V', 'W', 'X','Y','Z'];
    private _columns: any;
    sub: any;
    @Input()
    set columns(value) {
        this._columns = value;
    }
    get columns() {
        return this._columns;
    }

    constructor(private route: ActivatedRoute, private router: Router) {}
    alpha;
    ngOnInit() {
        var that = this;
        that.sub = that.route.params.subscribe(params => {
            if(params.alpha) {
                that.alpha = params.alpha.toUpperCase();
            }
        });
    }

    ngOnDestroy() {
      this.sub.unsubscribe();
    }

    click_search(item) {
        let partUrlArr = this.route.snapshot['_routerState'].url.split(';');
        let link = partUrlArr[0];
        let param = {};
        for (let i = 1; i < partUrlArr.length; i++) {
          let partUrl = partUrlArr[i];
          if (partUrl.startsWith('alpha=')) continue;
          let paramArr = partUrl.split('=');
          if (paramArr && paramArr.length > 1) {
            param[paramArr[0]] = paramArr[1];
          }
        }
        if(item) {
            param['alpha'] = item.toLowerCase();
        } else {
          this.alpha = null;
        }
        this.router.navigate([link, param]);
    }
}



// WEBPACK FOOTER //
// ./src/app/common/component/alphasearch/alphasearch.component.ts